import React from "react";
import { Form, Input, Typography } from "antd";
import { BulbOutlined } from "@ant-design/icons";
import { defaultHeroContent } from "./defaults";
import type { SectionMeta } from "./types";

const { Text } = Typography;

export const meta: SectionMeta = {
  key: "hero_content",
  label: "Hero Section",
  icon: <BulbOutlined />,
  color: "#f59e0b",
  desc: "Main hero banner title, subtitle and button",
};

export const defaultData = defaultHeroContent;

export const Preview: React.FC<{ data: any[] }> = ({ data }) => {
  if (data.length === 0) return null;
  const item = data[0];
  return (
    <div className="space-y-1 text-sm">
      <div className="font-semibold text-gray-800 truncate">
        {item.hero_title}
      </div>
      <div className="text-gray-500 text-xs truncate">{item.hero_subtitle}</div>
      {item.button_text && (
        <div className="text-xs text-amber-600 font-medium">
          Button: {item.button_text}
        </div>
      )}
    </div>
  );
};

export const FormFields: React.FC = () => (
  <Form.Item noStyle shouldUpdate={(prev, cur) => prev.hero_content !== cur.hero_content}>
    {({ getFieldValue }) => {
      const items = getFieldValue("hero_content") || defaultHeroContent;
      const item = items[0] || defaultHeroContent[0];
      return (
        <div className="space-y-3">
          <Text type="secondary" className="text-xs">
            Edit your hero banner content below.
          </Text>
          <Form.Item name={["hero_content", 0, "hero_title"]} label="Hero Title" rules={[{ required: true, message: "Required" }]}>
            <Input placeholder="e.g. Welcome to Our Store" />
          </Form.Item>
          <Form.Item name={["hero_content", 0, "hero_subtitle"]} label="Hero Subtitle" rules={[{ required: true, message: "Required" }]}>
            <Input placeholder="e.g. Discover amazing products" />
          </Form.Item>
          <Form.Item name={["hero_content", 0, "button_text"]} label="Button Text">
            <Input placeholder="e.g. Shop Now" />
          </Form.Item>
        </div>
      );
    }}
  </Form.Item>
);
